import React, { useState, useEffect, useRef, forwardRef } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { Input } from '..';
import './date-input.scss';

registerLocale('ru', ru);

const DateInput = ({
  placeholder,
  disabled,
  readOnly,
  onChange,
  onBlur,
  onReset,
  label,
  error,
  value,
  ...rest
}) => {
  const inputRef = useRef(null);
  const [date, setDate] = useState(null);

  useEffect(() => {
    setDate(value ? moment(value).toDate() : null);
  }, [value]);

  const InputRef = forwardRef((props, ref) => (
    <Input {...props} forwardRef={ref} />
  ));

  return (
    <div className="date-input">
      <DatePicker
        {...rest}
        selected={date}
        customInput={<InputRef ref={inputRef} label={label} error={error} onReset={onReset} />}
        onChange={onChange}
        onBlur={onBlur}
        placeholderText={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        locale="ru"
        dateFormat="dd.MM.yyyy"
        fixedHeight
      />
    </div>
  );
};

export default DateInput;
